export enum UserBundleRefundsStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PROCESSED = 'PROCESSED',
  PROCESSING_IN_PROGRESS = 'PROCESSING_IN_PROGRESS',
  PROCESSING_FAILED = 'PROCESSING_FAILED'
}
